import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  fetchGlobalCustomersAffiliates,
  getStoreValueByProp,
} from '../../store/subscriptionsSlice';
import CustomerAffiliateSelect from './CustomerAffiliateSelect';

const mapState = R.applySpec({
  globalCustomers: getStoreValueByProp(['globalCustomers']),
  globalCustomersAffiliates: getStoreValueByProp(['globalCustomersAffiliates']),
  globalCustomersAffiliatesLoading: getStoreValueByProp(['globalCustomersAffiliatesLoading']),
  globalCustomersLoading: getStoreValueByProp(['globalCustomersLoading']),
});

export default connect(mapState, { fetchGlobalCustomersAffiliates })(CustomerAffiliateSelect);
